import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Pricing from "./pages/Pricing";
import Booking from "./pages/Booking";
import Cities from "./pages/Cities";
import CityPage from "./pages/CityPage";
import Jobs from "./pages/Jobs";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import LandingPage from "./pages/LandingPage";
import Admin from "./pages/Admin";
import CleanerPortal from "./pages/CleanerPortal";
import CustomerBooking from "./pages/CustomerBooking";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Agb from "./pages/Agb";
import PopularSearches from "./pages/PopularSearches";
import { Toaster } from "./components/ui/toaster";
import { LANDINGS } from "./landingPages";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const PAGES = [
  { path: "/", el: <Home /> },
  { path: "/so-funktionierts", el: <HowItWorks /> },
  { path: "/preise", el: <Pricing /> },
  { path: "/buchen", el: <Booking /> },
  { path: "/staedte", el: <Cities /> },
  { path: "/putzfrau/:slug", el: <CityPage /> },
  { path: "/putzfrau-werden", el: <Jobs /> },
  { path: "/kontakt", el: <Contact /> },
  { path: "/ratgeber", el: <Blog /> },
  { path: "/ratgeber/:slug", el: <BlogArticle /> },
  { path: "/impressum", el: <Impressum /> },
  { path: "/datenschutz", el: <Datenschutz /> },
  { path: "/agb", el: <Agb /> },
  { path: "/beliebte-suchen", el: <PopularSearches /> },
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <Navbar />
          <Routes>
            {PAGES.map((p) => (
              <Route key={p.path} path={p.path} element={p.el} />
            ))}
            {PAGES.map((p) => (
              <Route key={`en${p.path}`} path={`/en${p.path === "/" ? "" : p.path}`} element={p.el} />
            ))}
            {LANDINGS.map((l) => (
              <Route key={l.slug} path={`/${l.slug}`} element={<LandingPage />} />
            ))}
            {LANDINGS.map((l) => (
              <Route key={`en-${l.slug}`} path={`/en/${l.slug}`} element={<LandingPage />} />
            ))}
            <Route path="/admin" element={<Admin />} />
            <Route path="/putzfrau-portal" element={<CleanerPortal />} />
            <Route path="/en/putzfrau-portal" element={<CleanerPortal />} />
            <Route path="/buchung/:token" element={<CustomerBooking />} />
          </Routes>
          <Footer />
          <Toaster />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
